import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { AlertService, ConfirmDialogService, LoaderEnabled, ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DockDoorBookingDataService } from '../../../../features/outbound/dock-door-booking/dock-door-booking-home/services/dock-door-booking-data.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';

@Component({
  selector: 'lfwms-door-schedule-popup',
  templateUrl: './door-schedule-popup.component.html',
  styleUrls: ['./door-schedule-popup.component.css']
})
export class DoorSchedulePopupComponent implements OnInit {

  private http$: HttpClient;
  private resourceService: ResourceService;
  protected confirmDialogService: ConfirmDialogService;
  private data: any;
  private dataService: DockDoorBookingDataService;
  private eventSubject = new Subject<any>();
  private tableId: string = 'doorblocktd';

  constructor(
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService) {
    this.http$ = coreServiceRegistry.http$;
    this.resourceService = coreServiceRegistry.resourceService;
    this.confirmDialogService = sharedServiceRegistry.confirmDialogService;
  }

  ngOnInit() {
  }

  initializeComponents(dataService: DockDoorBookingDataService, data: any) {
    this.dataService = dataService;
    this.data = data;
  }

  inboundBook() {
    this.cancel();
    this.notifyEvent({ type: 'inboundBook' });
  }

  outboundBook() {
    this.cancel();
    this.notifyEvent({ type: 'outboundBook' });
  }

  block() {
    this.cancel();
    this.notifyEvent({ type: 'block', data: this.data });
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  unblock() {
    let privilege = 'dock_door_access';
    this.confirmDialogService.confirmDialog(this.resourceService.get('msg_conf_del').replace('{}','blocking'))
      .subscribe((isConfirmed: any) => {
        if (isConfirmed) {
          this.deleteEntity(this.data.blockingId,privilege)
            .subscribe((resp: any) => {
              if (resp['statusCode'] && resp['statusMessage']) {
                if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                  this.alertService.clearAll();
                  this.alertService.success(this.resourceService.get('msg_del_succ'));
                  this.cancel();
                  //Refresh the calendar.
                  this.notifyEvent({ type: 'refresh' });
                } else if (resp['statusCode'] === 500) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.translateServerResponse(resp['statusMessage']));
                }
              } else {
                if (resp.error) {
                  this.alertService.clearAll();
                  this.alertService.error(this.resourceService.translateServerResponse(resp.error));
                }
              }
            }, (error) => {
              this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
            });
        }
      });
  }

  cancel() {
    this.sharedServiceRegistry.sceModalService.modalReference.hide();
  }

  getSelectedDoors() {
    let i = this.dataService.doors.findIndex((door) => door === this.data.fromDoor);
    let j = this.dataService.doors.findIndex((door) => door === this.data.toDoor);
    return this.dataService.doors.slice(i, (j + 1)).join(', ');
  }

  public getSelectedDate() {
    return moment(this.data.date).format('ddd, DD/MM/YYYY').toUpperCase();
  }

  @LoaderEnabled()
  // service call to delete an entity
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public deleteEntity(itemNumber: string, privilege: any): Observable<Response> {
    let request = [{
      'screenType': this.tableId,
      'moduleProperties': [{
        cName: 'blockSlotKey',
        cVal: itemNumber
      }],
      'privilege': privilege
    }];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    return this.http$.delete('api/setup/withPriv/', options)
    // LFWM-3191-handling 403-forbidden error.
      .catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/dock-door-booking-popups/door-schedule-popup/door-schedule-popup.component.ts